import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {
  Link,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar
} from '@mui/material';
import { useTheme } from '@mui/system';
import config from '@configFile';
import { useGetTopDeals } from '@hooks/useTopDeals';
import { DealPostType } from '@types';
import { parseTitle, getPostPrice } from '@utils/index';
import Title from '@pages/Blog/components/Title';
import PosterDetails from '@components/PosterDetails';

const getBackgroundStyle = (backgroundColor: string) => {
  return {
    backgroundColor,
    margin: '0px -17px',
    padding: '10px 17px'
  };
};

interface LinkTypeProps extends DealPostType {
  index: number;
}

const LinkType = (props: LinkTypeProps) => {
  const { ASIN, title, image, index } = props;

  return (
    <ListItem
      button
      component="a"
      href={`https://www.amazon.com/gp/product/${ASIN}/?fpl=fresh&psc=1&tag=${config.AFFILIATE_TAGS.HOW_TO_GET_DEAL}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <ListItemAvatar>
        <Avatar
          src={image}
          alt={title}
          sx={{ width: 56, height: 56, marginRight: '16px' }}
        />
      </ListItemAvatar>
      <ListItemText
        primary={`${index + 1}. ${parseTitle(title)}${getPostPrice(props)}`}
      />
    </ListItem>
  );
};

const TopDealsList = ({ postDate }: { postDate?: string | null }) => {
  const { data: topDeals } = useGetTopDeals();
  const theme = useTheme();
  if (!topDeals) {
    return null;
  }

  return (
    <Box>
      <Title
        title="Top 10 Best Selling Amazon Deals of the Past Week"
        backgroundColor="#4d6f8c"
        link="/p/best-selling-deals"
      />
      <Typography variant="caption" component="div">
        <Box sx={getBackgroundStyle(theme.palette.secondaryBackground)}>
          <PosterDetails postDate={postDate} />
        </Box>
      </Typography>
      <Box
        sx={{
          padding: '16px',
          marginLeft: '-17px!important',
          marginRight: '-16px!important'
        }}
        data-testid={postDate}
      >
        <List
          sx={{
            margin: '0 auto'
          }}
        >
          {topDeals.slice(0, 10).map((link, idx) => (
            <LinkType key={link.ASIN} {...link} index={idx} />
          ))}
        </List>
      </Box>
      <Typography variant="caption" component="div">
        <Box sx={getBackgroundStyle(theme.palette.secondaryBackground)}>
          <Link
            href="/p/best-selling-deals"
            variant="subtitle1"
            sx={{
              lineHeight: '1.5!important',
              margin: '12px 0 0px 0',
              paddingBottom: '16px',
              display: 'block',
              '@media (max-width: 540px)': {
                fontSize: '16px'
              }
            }}
          >
            See all most popular deals of the past week {' >>>'}
          </Link>
        </Box>
      </Typography>
    </Box>
  );
};

export default TopDealsList;
